import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const ProvenirApi = {
    async evaluateCreditCapacity({ clients, caseLoanInfo }) {
        const client = clients[0];
        const basicInfo = client.retailClientBasicInfo;
        const workInfo =client.retailClientWorkInfo

        const cedulaSolicitante = (
            basicInfo.identificationNumber ||
            basicInfo.passportNumber ||
            basicInfo.foreignIdNumber ||
            ""
        ).replace(/[^a-zA-Z0-9]/g, "");

        const payload = {
            Data: {
                Provenir: {
                    JMMB: {
                        Joli: {
                            IngresoNetoMensuales: basicInfo.monthlyIncome,
                            MontoSolicitado: caseLoanInfo.loanAmount,
                            PlazoSolicitado: caseLoanInfo.requestedTerm,
                            CedulaSolicitante: cedulaSolicitante,
                            FechaIngreso: workInfo.startDate
                        },
                    },
                },
            },
        };

        return checkErrors(await fetchApi.api.post('provenir/evaluateCreditCapacity', { data: payload }));
    },
};

export default ProvenirApi;
